// 매입지역 프리셋 — 17개 광역시·도 (2026-06-19). CRA src/ 밖 import 제약 회피용 클라이언트 로컬 상수.
// 차량 등록폼/수정모달 드롭다운 + 목록 컬럼 표시에 공통 사용.
export var BUY_REGION_PRESETS = [
  '서울', '부산', '대구', '인천', '광주', '대전', '울산', '세종',
  '경기', '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주'
];
